import React from 'react'

export default function Home() {
  return (
    <div className="bg-red-400">
      Hello
    </div>
  )
}
